module.exports = __webpack_public_path__ + "img/commercial-icon.86b70f3e.svg";